module.exports = __webpack_public_path__ + "static/media/pricetags.fe931850.svg";